import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuth } from '@/providers/AuthProvider';
import { buildWebLoginUrl } from '@/lib/urls';

type AuthGuardProps = {
  children: ReactNode;
};

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center text-sm text-brut-muted">
        Checking session…
      </div>
    );
  }

  if (!isAuthenticated) {
    const returnUrl = `${window.location.origin}${location.pathname}${location.search}`;
    const loginUrl = buildWebLoginUrl(returnUrl);
    window.location.assign(loginUrl);
    return (
      <div className="flex min-h-[50vh] items-center justify-center text-sm text-brut-muted">
        Redirecting to sign in…
      </div>
    );
  }

  return <>{children}</>;
}
